import Styles from './UserQuiz.module.scss';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Module imports.
import axios from 'axios';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';

// Components import
import { useAPI, Message, AuthContext } from 'components/lib';
import QuizGridViewCard from 'components/global/QuizGridViewCard/QuizGridViewCard';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';
import { useContext } from 'react';

export function UserQuiz(props) {

	const navigate = useNavigate();
	const context = useContext(AuthContext)
	const [isLoadingOpen, setIsLoadingOpen] = useState(false);

	// Helper function to get the index of a array in streamList from id
	function findDictionaryIndex(array, key, value) {
		for (let index = 0; index < array.length; index++) {
			const dictionary = array[index];
			if (dictionary.hasOwnProperty(key) && dictionary[key] === value) {
				return index;
			}
		}
		return -1; // Return -1 if the dictionary is not found
	}
	const { data, loading: labsLoading } = useAPI(`/api/user/quizzes`, 'GET');
	useEffect(() => {
		if (data?.length) {
			const updatedLabList = data.map((lab) => ({
				...lab,
				isDisabled: false,
				buttonText:
					lab.level === 3 && lab.badge !== 0 ?
						props.t('CommonQuiz.UserQuiz.button.completed') :
						lab.status === 'in_progress' ?
							props.t('CommonQuiz.UserQuiz.button.continue') :
							lab.status === 'failed' ?
								props.t('CommonQuiz.UserQuiz.button.retake') :
								props.t('CommonQuiz.UserQuiz.button.start'),
				labelText: lab.level === 1 ? props.t('CommonQuiz.UserQuiz.level.one') :
					lab.level === 2 ? props.t('CommonQuiz.UserQuiz.level.two') :
						props.t('CommonQuiz.UserQuiz.level.three'),
			}));
			setUserLabs(updatedLabList);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	const [userLabs, setUserLabs] = useState([]);

	const handleQuizClick = (data) => {
		const id = data.id;
		const index = findDictionaryIndex(userLabs, 'id', `${id}`);
		const labStatus = userLabs[index].status;
		const options = {
			method: 'POST',
			url: `/api/user/quizzes/${id}/assign`,
			headers: {
				accept: 'application/json',
			},
		};
		if (labStatus === 'not_started') {
			setIsLoadingOpen(true);
			axios
				.request(options)
				.then(async function (response) {
					await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen
					setIsLoadingOpen(true);
					navigate(`/quizzes/${id}/level`);
				})
				.catch((err) => {
					console.log(err.response);
					navigate('/oops');
				});
		} else {
			navigate(`/quizzes/${id}/level`);
		}
	};

	const handleShare = (data) => {
		const id = data;
		navigate(`/quizzes/${id}/userBadge`);
	};

	function handleEnrollClick() {
		navigate(`/quiz/all`);
	}

	return (
		<>
			{context?.user?.onboarded ? (
				<Message
					closable
					title={props.t('CommonQuiz.UserQuiz.message.title')}
					text={props.t('CommonQuiz.UserQuiz.message.descr')}
					type="info"
				/>
			) : (
				<Message
					title={'Profile Setup Pending'}
					text={'Please complete your profile setup to unlock all features and get started.'}
					type="warning"
					buttonText={'Setup Profile'}
					buttonLink={'/account'}
				/>
			)}

			<LoadingBackdrop isOpen={isLoadingOpen} />
			<div className={Styles.CardContainer}>
				<div className={Styles.tabContainer}>
					<BreadCrumbs
						onClickPaths={[
							''
						]}
						crumbs={props.t('CommonQuiz.UserQuiz.breadCrumbs', { returnObjects: true })}
					/>
					<button
						variant="extended"
						className={Styles.enrollButton}
						onClick={() => {
							handleEnrollClick();
						}}
					>
						<AddCircleOutlineTwoToneIcon />
						{props.t('CommonQuiz.UserQuiz.enroll')}
					</button>
				</div>
				<div
					id="parentContainer"
					style={{
						flexWrap: 'wrap',
						alignItems: (labsLoading === 'Loading') & (userLabs.length > 0) ? 'center' : 'none',
					}}
				>
					{labsLoading ? (
						<div>
							<LoadingBackdrop isOpen={true} />
						</div>
					) : userLabs.length > 0 ? (
						<div style={{ display: 'flex', flexWrap: 'wrap' }}>
							{userLabs.map((lab) => {
								return (
									<QuizGridViewCard
										data={lab}
										key={lab.id}
										quizClick={handleQuizClick}
										shareClick={handleShare}
										button_text={lab.buttonText}
										showInfoChips={true}
										showMedalChips={true}
										label_Text={lab.labelText}
									/>
								);
							})}
						</div>
					) : (
						<div id="enrollContainer" className={Styles.enrollContainer}>
							<div className={Styles.contentContainer}>
								<p>{props.t('CommonQuiz.UserQuiz.info.message1')}</p>
								<p>{props.t('CommonQuiz.UserQuiz.info.message2')}</p>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
	// }
}
